module.exports = __webpack_public_path__ + "static/media/statistics-1.982fab35.png";